import { render, staticRenderFns } from "./marKetingLotteryRecord.vue?vue&type=template&id=42de3072&scoped=true&"
import script from "./marKetingLotteryRecord.vue?vue&type=script&lang=js&"
export * from "./marKetingLotteryRecord.vue?vue&type=script&lang=js&"
import style0 from "./marKetingLotteryRecord.vue?vue&type=style&index=0&id=42de3072&scoped=true&lang=css&"
import style1 from "./marKetingLotteryRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de3072",
  null
  
)

export default component.exports